import React from 'react';
import clsx from 'clsx';

// REACT-ROUTER-DOM
import {useHistory, Route,  Switch, Link } from 'react-router-dom';

// REDUX
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';

//ICONOS
import { Drawer, CssBaseline, AppBar , Toolbar, Typography, Button, Icon, Menu as MuiMenu, MenuItem } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import ArticleIcon from '@mui/icons-material/Article';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { HelpOutline } from '@mui/icons-material';

// COMPONENTES
import RutasPrivadas from 'commons/RutasPrivadas';
import { publicMenu } from 'constantes/index';
import Home from 'pages/Home/';
import Login from 'pages/Security/Login/';
import MenuVertical from 'components/MenuVertical';
import PerfilDelUsuario from 'pages/UserProfile';

import UserAccount from 'pages/Security/Login/FormElements/UserAccount';
// ESTILOS
import {useStyles} from './Style';
import Television from 'pages/tarifarios/television';
import { Download, DownloadOutlined, Help } from '@mui/icons-material';
import Radio from 'pages/tarifarios/radio';
import Escritos from 'pages/tarifarios/escritos';
import Calendario from 'pages/calendario';
import PantallaDigital from 'pages/tarifarios/pantallaDigital';
import VallasFijas from 'pages/tarifarios/vallasFijas';
import VallasMoviles from 'pages/tarifarios/vallasMoviles';
import RedesSociales from 'pages/redesSociales';
import ElaboracionPlanDeMedios from 'pages/elaboracionPlanDeMedios';
import RegistroDeUsuarios from 'pages/registroDeUsuarios';
import ValidarTarifario from 'pages/calendario/ValidarTarifario';
import CatalogosDeMedios from 'pages/catalogosDeMedios';
import PlanDeMediosIntegrado from 'pages/planDeMediosIntegrado';
import VallasYPantallas from 'pages/reportes/VallasYPantallas';
import PlanDeMediosAlternos from 'pages/planDeMediosAlternos';
import ValidarInformacionQR from 'pages/validarQRVallas';
import PlanDeMediosIntegradoPrueba from 'pages/planDeMediosPrueba';
import GeneracionSolicitudTransmision from 'pages/generacionSolicitudTransmision';
import ListadoSolicitudesTransmision from 'pages/listadoSolicitudesTransmision';
import ManifestarDisersion from 'pages/manifestarDisension';
import OrdenesDeTransmision from 'pages/OrdenesDeTransmision';
import ConformidadDeEjecucionDelPlan from 'pages/ConformidadEjecucionPlan';
import RegistroDeMediosComunicacion from 'pages/registroDeMediosComunicacion';
//import ObtenerCorreoUsuario from 'pages/Security/Login/CambiarContraseña/ObtenerCorreo'

const Menu = (props)=> {
    const classes = useStyles(props);
    var authenticated =props.authenticated;
    const [open] = React.useState(false);
    const [declaracionAnchorEl, setDeclaracionAnchorEl] = React.useState(null);
    let history = useHistory();
    const mostrarMenuDeclaraciones = Boolean(declaracionAnchorEl);

    const abrirMenuDeclaraciones = (event) => {
        setDeclaracionAnchorEl(event.currentTarget);
    }

    const cerrarMenuDeclaraciones = () => {
        setDeclaracionAnchorEl(null);
    }

    const descargarDeclaracionJurada = (nombreDeArchivo) => {
        const rutaDelArchivo = `${process.env.PUBLIC_URL}/declaraciones-juradas/${encodeURIComponent(nombreDeArchivo)}`;
        const enlaceDeDescarga = document.createElement('a');
        enlaceDeDescarga.href = rutaDelArchivo;
        enlaceDeDescarga.download = nombreDeArchivo;
        document.body.appendChild(enlaceDeDescarga);
        enlaceDeDescarga.click();
        document.body.removeChild(enlaceDeDescarga);
        cerrarMenuDeclaraciones();
    }

    const onLogout =()=>{
        let userAccount = new UserAccount();
        userAccount.logout();
        props.LOGOUT();
        props.SET_MENU(publicMenu);
        history.push("/login",{})
    }

  return (
    <div className={classes.root}>
        <CssBaseline />
            <AppBar position="fixed"
                    className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
            })}>
                <Toolbar className={classes.toolbar}>
                    <Typography variant="h6" className={classes.title} >
                        <div className={classes.appTitle} to="/">
                            <img className={classes.appIcon} src="assets/WhiteIcon.svg"  alt="fireSpot"/>
                            TRIBUNAL SUPREMO ELECTORAL V.2.0.0
                        </div>
                    </Typography>
                { authenticated ? (
                    <div>
                        {/* <Button className={classes.button} color="inherit" to="/planDeMediosIntegrado" component={Link} >
                        <Icon className={classes.icon}><MenuIcon /></Icon>
                        <span className={classes.title_text}>Plan de medios integrado</span>
                        </Button> */}
                        <Button className={classes.button} color="inherit" onClick={abrirMenuDeclaraciones}>
                            <Icon className={classes.icon}><Download /></Icon>
                            <span className={classes.title_text}>Descargar Declaración Jurada</span>
                        </Button>
                        <MuiMenu
                            anchorEl={declaracionAnchorEl}
                            open={mostrarMenuDeclaraciones}
                            onClose={cerrarMenuDeclaraciones}
                        >
                            <MenuItem onClick={() => descargarDeclaracionJurada('Declaración jurada persona individual alternativos.docx')}>Declaración jurada persona individual alternativos</MenuItem>
                            <MenuItem onClick={() => descargarDeclaracionJurada('Declaración jurada persona individual tradicionales.docx')}>Declaración jurada persona individual tradicionales</MenuItem>
                            <MenuItem onClick={() => descargarDeclaracionJurada('Declaración jurada persona juridica alternativos.docx')}>Declaración jurada persona jurídica alternativos</MenuItem>
                            <MenuItem onClick={() => descargarDeclaracionJurada('Declaración jurada persona juridica tradicionales.docx')}>Declaración jurada persona jurídica tradicionales</MenuItem>
                        </MuiMenu>
                        <Button className={classes.button} color="inherit" href='https://ayudaportalweb.tse.org.gt/es/Registro_Tarifario_medios_sociales' target='_blank'>
                            <Icon className={classes.icon}><Help /></Icon>
                            <span className={classes.title_text}>Ayuda</span>
                        </Button>
                        <Button className={classes.button} color="inherit"  to='/' component={Link}>
                            <Icon className={classes.icon}><MenuIcon/></Icon>
                            <span className={classes.title_text}>Menú</span>
                        </Button>
                        <Button className={classes.button} color="inherit"  to='/PerfilDelUsuario' component={Link} >
                                <Icon className={classes.icon}><AccountCircleIcon/></Icon>
                                <span className={classes.title_text}>Perfil</span>
                        </Button>
                        <Button className={classes.button} color="inherit"
                                onClick={onLogout} >
                                <Icon className={classes.icon}><LockIcon/></Icon>
                                <span className={classes.title_text}>Cerrar sesión</span>
                        </Button>
                    </div>
                    ) : (
                        <div>
                            <Button className={classes.button} color="inherit" href="https://ayudaportalweb.tse.org.gt/"  target='_blank' >
                                <Icon className={classes.icon}><HelpOutline /></Icon>
                                <span className={classes.title_text}>Ayuda</span>
                            </Button>
                            
                            <Button className={classes.button} color="inherit" to='/login' component={Link}>
                                <Icon  className={classes.icon}>person</Icon>
                                <span className={classes.title_text}>Iniciar sesión</span>
                            </Button>
                            <Button className={classes.button} color="inherit" href="https://portalweb.tse.org.gt/signup" target='_blank' >
                                <Icon className={classes.icon}><PersonAddIcon /></Icon>
                                <span className={classes.title_text}>Registro</span>
                            </Button>
                        </div>
                    )}
            </Toolbar>
        </AppBar>

        <Drawer className={classes.drawer}  variant="persistent"    anchor="left"
                open={open} classes={{  paper: classes.drawerPaper,}}
        >
            <MenuVertical/>
        </Drawer>

        <main className={clsx(classes.content, { [classes.contentShift]: open,})}>
            <Switch>
                <RutasPrivadas exact path="/" authenticated={authenticated} currentUser={props.currentUser} component={Home}></RutasPrivadas>
                <RutasPrivadas exact path="/PerfilDelUsuario" authenticated={authenticated} currentUser={props.currentUser} component={PerfilDelUsuario}></RutasPrivadas>

                {/* TARIFARIOS */}
                <RutasPrivadas exact path="/television" authenticated={authenticated} currentUser={props.currentUser} component={Television}/>
                <RutasPrivadas exact path="/radio" authenticated={authenticated} currentUser={props.currentUser} component={Radio}/>
                <RutasPrivadas exact path="/escritos" authenticated={authenticated} currentUser={props.currentUser} component={Escritos}/>

                {/* MEDIOS ALTERNATIVOS */}
                <RutasPrivadas exact path="/pantallaDigitales" authenticated={authenticated} currentUser={props.currentUser} component={PantallaDigital}/>
                <RutasPrivadas exact path="/vallasFijas" authenticated={authenticated} currentUser={props.currentUser} component={VallasFijas}/>
                <RutasPrivadas exact path="/vallasMoviles" authenticated={authenticated} currentUser={props.currentUser} component={VallasMoviles}/>

                {/* REDES SOCIALES */}
                <RutasPrivadas exact path="/registroDeFacebook" authenticated={authenticated} currentUser={props.currentUser} component={ () => <RedesSociales redSocial="facebook" />} />
                <RutasPrivadas exact path="/registroDeInstagram" authenticated={authenticated} currentUser={props.currentUser} component={ () => <RedesSociales redSocial="instagram" />} />

                {/* ORGANIZACIONES POLITICAS */}
                <RutasPrivadas exact path="/elaboracionPlanMedios2" authenticated={authenticated} currentUser={props.currentUser} component={Calendario}/>

                <RutasPrivadas exact path="/elaboracionPlanMedios" authenticated={authenticated} currentUser={props.currentUser} component={ElaboracionPlanDeMedios}/>
                <RutasPrivadas exact path="/planDeMediosAlternativos" authenticated={authenticated} currentUser={props.currentUser} component={PlanDeMediosAlternos}/>
                <RutasPrivadas exact path="/planDeMediosIntegrados" authenticated={authenticated} currentUser={props.currentUser} component={PlanDeMediosIntegradoPrueba}/>
                <RutasPrivadas exact path="/generacionTransmisionConformidad" authenticated={authenticated} currentUser={props.currentUser} component={GeneracionSolicitudTransmision}/>
                {/* <RutasPrivadas exact path="/planDeMediosIntegrados" authenticated={authenticated} currentUser={props.currentUser} component={ManifestarDisersion}/> */}

                {/* <RutasPrivadas exact path="/planDeMediosIntegrados" authenticated={authenticated} currentUser={props.currentUser} component={ListadoSolicitudesTransmision}/> */}
                {/* <RutasPrivadas exact path="/elaboracionPlanMedios" authenticated={authenticated} currentUser={props.currentUser} component={ValidarTarifario}/> */}
                <RutasPrivadas exact path="/ordenesDeTransmisionMedio" authenticated={authenticated} currentUser={props.currentUser} component={OrdenesDeTransmision}/>

                <RutasPrivadas exact path="/conformidadEjecucionDelPlan" authenticated={authenticated} currentUser={props.currentUser} component={ConformidadDeEjecucionDelPlan}/>

                <Route exact path="/catalogosDeMedios" component={CatalogosDeMedios}/>

                {/* REGISTRO DE MEDIOS DE COMUNICACION */}
                <RutasPrivadas exact path="/registroDeMediosComunicacion" authenticated={authenticated} currentUser={props.currentUser} component={RegistroDeMediosComunicacion}/>

                {/* <Route exact path="/planDeMediosIntegrado" component={PlanDeMediosIntegrado}/> */}
                <Route exact path="/reportesVallasyPantallas" component={VallasYPantallas}/>
                <Route exact path="/planDeMediosIntegradoPrueba" component={PlanDeMediosIntegradoPrueba}/>

                <Route exact path="/informacionPublica/validarMedioDeComunicacion/:codigoUnico" render={() => <ValidarInformacionQR />}></Route>

                {/* <Route exact path="/cambiarContraseña/obtenerCorreoExterno" render={(props) => <ObtenerCorreoUsuario />}></Route> */}
                <Route exact path="/login" render={() => <Login/>}></Route>
                <Route exact path="*" render={() => <Login />}></Route>
            </Switch>
        </main>

    </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
